import { CollectionLiveData } from '@components/collections/Model';
import { BaseApiParams } from '@services/Types';

export class ShareComparisonChartResp {
  salesRecordsFound = true;
  value = new ValueChartResp();
  volume = new VolumeChartResp();
}

export interface ShareComparisonParam extends BaseApiParams, CollectionLiveData {
  saleType: string;
  isSummary: boolean;
}

export class ValueChartResp {
  marketValue: BaseChartResp[] = [];
  retailerValue: BaseChartResp[] = [];
  retailerValueShare: BaseChartResp[] = [];
  retailerValueMixShare: BaseChartResp[] = [];
}

export class VolumeChartResp {
  marketVolume: BaseChartResp[] = [];
  retailerVolume: BaseChartResp[] = [];
  retailerVolumeShare: BaseChartResp[] = [];
  retailerVolumeMixShare: BaseChartResp[] = [];
}

export class BaseChartResp {
  period: string = '';
  value: number = 0;
}
